export default function(path) {
  const currentPath = window.location.pathname + window.location.hash

  if (currentPath === path) {
    window.location.reload()
  } else {
    window.location.href = path
  }
}
